import {createContext} from "react"
import {ContentCard, ContentCardBanner, LegacyNotificationCard} from "./ContentCard"

export const initial: Context = {
  notifications: [],
  notificationsCount: 0,
  banners: []
}
export type Context = {
  notifications: LegacyNotificationCard[]
  notificationsCount: number
  banners: ContentCardBanner[]
  contentCardPopup?: ContentCard
}

export type ActionsContext = {
  showPopup(contentCard: ContentCard): void
  clearPopup(): void
  refresh(): void
  markContentCardClicked(id: string): void
  markContentCardsImpression(ids: string[]): void
  markContentCardsDismissed(ids: string[]): void
}

export const NotificationContext = createContext<Context>(initial)
export const NotificationActionContext = createContext<ActionsContext | null>(null)
